<template>
    <div class="forex-container">
        <router-link
            v-if="formData.type === 0 || type === 0"
            class="tools-bot__header-nav"
            :to="{ name: 'forex-license' }"
        >
            <div class="tools-bot__header-nav_icon">
                <v-icon src="back-arrow" />
            </div>
            PlatformFX
        </router-link>
        <router-link v-if="formData.type === 1 || type === 1" class="tools-bot__header-nav" :to="{ name: 'idea-fx' }">
            <div class="tools-bot__header-nav_icon">
                <v-icon src="back-arrow" />
            </div>
            IdeaFX
        </router-link>
        <v-loading v-if="loading" />
        <div class="inner-wrapper" v-else>
            <div class="forex-application-wrapper">
                <div :class="statusClass" class="status-box" v-if="showAlert">
                    <div class="left">
                        <v-icon :src="statusIcons[status.id]" />
                    </div>
                    <div class="right">
                        <div class="subtitle">{{ status.label }}</div>
                        <p class="text" v-if="status.text">{{ status.text }}</p>
                    </div>
                </div>
                <div class="page-instructions">
                    <div style="display: flex; align-items: center">
                        <v-icon src="info-yellow" />
                        Инструкция для подключения робота.
                        <a target="_blank" :href="manualUrl">Смотреть</a>
                    </div>
                </div>
                <div class="form-container">
                    <v-form class="form-application" id="form-application">
                        <div class="form-group-wrap">
                            <div class="form-group__ttl">Forex</div>
                            <v-input
                                :error="errorType === 'login' ? error : null"
                                :readonly="!isEditable"
                                autocomplete="off"
                                copy
                                name="login"
                                rules="required"
                                title="Логин*"
                                v-model="formData.forex.login"
                            />
                            <br />
                            <v-password
                                :error="errorType === 'password' ? error : null"
                                :readonly="!isEditable"
                                autocomplete="off"
                                name="password"
                                rules="required"
                                title="Пароль*"
                                v-model="formData.forex.password"
                            />
                            <br />
                            <v-select
                                :error="errorType === 'server' ? error : null"
                                :options="serversList"
                                autocomplete="off"
                                name="server"
                                rules="required"
                                title="Сервер*"
                                v-model="formData.forex.server"
                            />
                            <br />
                            <div v-if="formData.type === 1 || type === 1">
                                <v-select
                                    v-if="!this.id"
                                    :error="errorType === 'sub_type' ? error : null"
                                    :options="subTypesList"
                                    autocomplete="off"
                                    name="sub_type"
                                    rules="required"
                                    title="Тип*"
                                    v-model="formData.sub_type"
                                />
                                <v-input
                                    v-else
                                    :error="errorType === 'sub_type' ? error : null"
                                    readonly
                                    disabled
                                    autocomplete="off"
                                    name="sub_type"
                                    rules="required"
                                    title="Тип*"
                                    v-model="subTypesList[formData.sub_type].label"
                                />
                            </div>
                        </div>
                        <div class="form-group-wrap">
                            <div class="form-group__ttl">Server</div>
                            <v-input
                                :error="errorType === 'login' ? error : null"
                                :readonly="!isEditable"
                                autocomplete="off"
                                copy
                                name="serverLogin"
                                rules="required"
                                title="Логин*"
                                v-model="formData.server.login"
                            />
                            <br />
                            <v-password
                                :error="errorType === 'password' ? error : null"
                                :readonly="!isEditable"
                                autocomplete="off"
                                name="serverPassword"
                                rules="required"
                                title="Пароль*"
                                v-model="formData.server.password"
                            />
                            <br />
                            <v-input
                                :error="errorType === 'ip' ? error : null"
                                :readonly="!isEditable"
                                autocomplete="off"
                                copy
                                name="ip"
                                rules="required"
                                title="IP*"
                                v-model="formData.server.ip"
                            />
                        </div>
                    </v-form>
                    <button class="btn" @click="sendApplication" form="form-application" v-if="isEditable">
                        {{ canUploadApp ? "Обновить" : "Отправить" }} заявку
                    </button>
                    <p v-if="isEditable && !canUploadApp">
                        <br />
                        Нажимая кнопку «Отправить заявку» вы соглашаетесь с тем что<br />
                        ознакомились с <a href="/docs/platformfx_offer.pdf" target="_blank">офертой</a>
                    </p>
                </div>
            </div>
            <div v-if="hasLicense" class="forex-license-info">
                <v-input :copy="!!license.key" :value="license.key" disabled name="license-key" title="Ключ:" />
                <v-input :value="license.valid_to" disabled name="license-over" title="Дата окончания:" />
            </div>
        </div>
    </div>
</template>

<script>
import PlOrdersTab from "../components/PlOrdersTab";
import PlForexStatistics from "../components/PlForexStatistics";
import SwitchCheckbox from "../../../common/components/form/SwitchCheckbox";
import { api } from "../services";

const statuses = {
    0: "wait",
    1: "ok",
    2: "wait",
    3: "reject"
};

const subTypesList = [
    {
        label: "Валютные пары",
        value: 0
    },
    {
        label: "Золото",
        value: 1
    },
    {
        label: "Робот",
        value: 2
    }
];

const statusIcons = {
    0: "load",
    1: "ok-green",
    2: "load",
    3: "error"
};

export default {
    name: "PlForexOrderPage",
    components: {
        PlOrdersTab,
        PlForexStatistics,
        SwitchCheckbox,
        "forex-instructions": () => import("../pages/PlForexInstructions")
    },
    $_veeValidate: {
        validator: "new"
    },
    props: {
        type: null,
        isDemo: {}
    },
    data() {
        return {
            id: null,
            statuses,
            statusIcons,
            subTypesList,
            errorType: null,
            loading: false,
            isOpenManual: false,
            formData: {
                forex: {
                    login: "",
                    password: "",
                    server: ""
                },
                server: {
                    login: "Administrator",
                    password: "",
                    ip: ""
                },
                sub_type: null,
                type: null,
                is_test: false
            },
            license: {
                key: null,
                valid_to: null
            },
            history: [],
            serversList: [],
            status: null,
            isEditable: true
        };
    },
    created() {
        if (this.$route.params.id) {
            this.id = this.$route.params.id;
            this.fetchOrder(this.id);
        }
        this.formData.is_test = this.isDemo;
        this.formData.type = this.type;
        this.fetchServers();
    },
    computed: {
        manualUrl() {
            return this.isDemo
                ? "https://telegra.ph/Podklyuchit-test-robota-10-30"
                : "https://telegra.ph/Kak-podklyuchit-robota-10-30 ";
        },
        hasLicense() {
            if (this.isModerator) {
                return this.license.key;
            }
            return this.status && this.license.key;
        },
        canUploadApp() {
            return [0, 1, 2, 3, 7].includes(this.status?.id);
        },
        showAlert() {
            return [0, 2, 3].includes(this.status?.id);
        },
        statusBoxDescription() {
            return this.profile.info.access.valid_to !== null
                ? "Дата окончания" + this.profile.info.access.valid_to
                : "Для получения доступа к сервису требуется оплата.";
        },
        statusBoxTitle() {
            return this.profile.info.access.valid_to !== null ? "Работает" : "Доступ ограничен";
        },
        statusClass() {
            return this.statuses[this.status.id];
        }
    },
    methods: {
        toggleManual() {
            this.openModal("PlForexManual", { from: "profile" });
        },
        fetchServers() {
            api.getServerList().then(({ data }) => {
                this.serversList = data.map(item => ({ label: item.name, value: item.id }));
            });
        },
        fetchOrder(id) {
            api.getOrder(id).then(data => {
                if (!data) {
                    return;
                }
                this.formData = {
                    forex: data.data.forex,
                    server: data.data.server,
                    type: data.data.type,
                    sub_type: data.data.sub_type
                };
                this.license = data.data.license;
                this.id = data.data.id;
                this.status = data.data.status;
                this.settings = data.data.settings;
                this.isEditable = data.data.is_editable;
            });
        },
        sendApplication() {
            this.validate()
                .then(() => {
                    let method = this.canUploadApp ? "put" : "post";

                    if (method === "put") {
                        api.updateApplication(this.id, this.formData)
                            .then(({ data }) => {
                                this.status = data.status;

                                this.notify({ title: "Заявка успешно изменена" });
                            })
                            .catch(e => {
                                this.notify({ title: e.data.description, type: "error" });
                            });
                    } else {
                        api.sendApplication(this.formData)
                            .then(({ data }) => {
                                this.status = data.status;
                                this.id = data.id;
                                this.notify({ title: "Заявка успешно отправлена" });
                            })
                            .catch(e => {
                                this.notify({ title: e.data.description, type: "error" });
                            });
                    }
                })
                .catch(() => {
                    this.notify({ title: "Ошибка", text: "Не все поля заполнены", type: "error" });
                });
        },
        changeStatus(status, reason = null) {
            return api.setApplicationStatus(this.id, status, reason).then(({ data }) => {
                this.isEditable = data?.is_editable;
                this.$set(this, "status", data.status);
                return data;
            });
        },
        generateLicense() {
            return api.getLicenseKey(this.id).then(({ data }) => {
                this.license = data.license;
            });
        },
        rejectApplication() {
            this.openModal("ContractDecline", {
                btnText: "Отправить"
            }).then(reason => {
                this.changeStatus("declined", reason);
            });
        }
    }
};
</script>

<style scoped lang="scss">
.admin-actions {
    display: flex;

    .v-button {
        margin-right: 10px;
    }

    .status {
        font-size: 14px;
        font-weight: 700;
        display: flex;
        margin-bottom: 20px;

        .svg-icon {
            margin-right: 5px;
        }
    }
}

.form-container {
    margin-bottom: 20px;
    max-width: 810px;
    width: 100%;

    &.is-disabled {
        padding: 30px;
        border-radius: 12px;
        background: linear-gradient(to bottom, #fcfcfc 00%, #f0eff1 46%);
    }
}

.status-box {
    max-width: 550px;
    width: 100%;
    padding: 17px;
    padding-right: 40px;
    background: #fff;
    border: 1px solid #faac15;
    border-radius: 2px;
    display: flex;
    margin-bottom: 20px;

    &.ok {
        border-color: #28cc6c;
    }

    &.reject {
        border-color: #f65844;
    }

    .left {
        margin-right: 18px;
        padding-top: 4px;
    }

    .subtitle {
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: #1d2228;
        margin-bottom: 8px;
    }

    p {
        font-size: 14px;
        line-height: 20px;
        color: #58606e;
        margin: 0;
    }
}

/*.application-history {
                &-ttl {
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 24px;
                    margin-bottom: 14px;
                }

                .table {
                    max-width: 800px;
                    width: 100%;
                    border: none;

                    &-header,
                    &-row {
                        display: flex;
                        justify-content: space-between;
                    }

                    &-header {
                        border-bottom: 1px solid #ebeff5;

                        &__item {
                            font-weight: normal;
                            font-size: 12px;
                            line-height: 14px;
                            color: #58606e;
                        }
                    }

                    &-body__item {
                        font-weight: normal;
                        font-size: 14px;
                        line-height: 24px;
                    }

                    &-row {
                        padding: 20px 8px;
                        border-bottom: 1px solid #ebeff5;
                    }

                    &-item {
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        width: 100%;
                        padding: 8px;
                    }
                }
            }*/

.btn-accept-application {
    margin-bottom: 24px;
}

.page-back {
    margin-bottom: 0;
}

.page-instructions {
    display: flex;
    align-items: center;
    margin-bottom: 26px;

    .svg-icon {
        margin-right: 10px;
        font-size: 20px;
    }
}

.form {
    &-application {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;

        .form-group-wrap {
            width: 100%;
            border-radius: 12px;

            &:first-child {
                margin-right: 40px;
            }
        }

        .form-group {
            margin-bottom: 6px;
        }

        .form-group__ttl {
            display: inline-block;
            font-weight: 500;
            font-size: 18px;
            margin-bottom: 10px;
        }

        @media (max-width: 680px) {
            flex-direction: column;
            .form-group-wrap:first-child {
                margin-bottom: 20px;
            }
        }
    }
}

.forex-license-info {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: 800px;
    padding: 20px 0;
    border-radius: 16px;
    /*    <!--box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.2);-->
                <!--background-color: #c3cbdc;-->
                <!--background-image: linear-gradient(-47deg, #c3cbdc 0%, #edf1f4 84%);-->*/

    .form-group {
        width: 100%;

        input {
            color: #333;
        }

        &:first-child {
            max-width: 380px;
            margin-bottom: 20px;
        }

        &:last-child {
            max-width: 200px;
        }

        @media (max-width: 440px) {
            input {
                font-size: 2.8vw;
            }
        }
    }
}

.forex-container {
    padding: 30px;
    @media (max-width: 768px) {
        padding: 20px 12px;
    }
}

.create-course-box__start-nav {
    margin-bottom: 0 !important;
}

.inner-wrapper {
    padding-top: 20px;
    background: #fff;
    @media (min-width: 769px) {
        margin-top: 0;
        padding: 30px;
    }
}

.page {
    &-header {
        margin: 0;
    }

    &-title {
        line-height: 1;
        margin: 0;
        display: inline-block;
        font-weight: bold;
        font-size: 18px;
    }

    &-subtitle {
        display: inline-block;
        font-size: 12px;
        color: #58606e;
    }
}

@media (min-width: 769px) {
    .inner-wrapper {
        margin-top: 0;
        padding: 30px;
    }
    .page {
        &-title {
            font-size: 24px;
            line-height: 40px;
        }

        &-subtitle {
            font-size: 14px;
        }
    }
}
</style>
